export class CronExpressionDto {
  id: string;
  cronExpression: string;
  businessDescription: string;
  startDate = '';
  type: 'CRON' | 'FISCAL_MONTH' = 'CRON';

  constructor(d?: CronExpressionDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.type = d.type || 'CRON';
    this.cronExpression = d.cronExpression;
    this.businessDescription = d.businessDescription;
    this.startDate = d.startDate || '';
  }
}
